import React from 'react'

const Completion = () => {
  return (
    <div className='step-container final-step'>
      <div className='success-icon'>✓</div>
      <h2>Check-in Complete!</h2>
      <p>Thank you for checking in. Your appointment has been confirmed.</p>

      {/* <div className='medical-history-section'>
        <h3>Important: Update Your Medical History</h3>
        <p>Please confirm and update your medical history using our mobile app before your appointment.</p>

        <div className='qr-code-section'>
          <div className='qr-code-placeholder'>
            <div className='qr-code'>
              <div className='qr-pattern'>
                <div className='qr-square'></div>
                <div className='qr-square'></div>
                <div className='qr-square'></div>
                <div className='qr-square'></div>
                <div className='qr-square'></div>
                <div className='qr-square'></div>
                <div className='qr-square'></div>
                <div className='qr-square'></div>
                <div className='qr-square'></div>
              </div>
            </div>
          </div>
          <p className='qr-instructions'>Scan this QR code with your phone camera to download our app</p>
        </div>

        <div className='app-links'>
          <p>Or download directly:</p>
          <div className='store-links'>
            <button className='store-btn apple'>App Store</button>
            <button className='store-btn google'>Google Play</button>
          </div>
        </div>
      </div> */}

      <button onClick={() => window.location.reload()} className='btn-secondary'>
        Start New Check-in
      </button>
    </div>
  )
}

export default Completion
